/**
 * 青山科技页面
 */
import React, { useState } from 'react';
import { Tabs } from '@roo/roo';
const { Pane: TabPane } = Tabs;
import { personData2021, personData2022, personData2023, personData2024 } from './personData';
import './laureates.scss';
import Partner from '../../../components/Partner/Partner';
import AwardHeader from '../../../components/AwardHeader/AwardHeader';

const yearArray = ['2024', '2023', '2022', '2021'];

const laureatesData = {
  2024: personData2024,
  2023: personData2023,
  2022: personData2022,
  2021: personData2021,
};

function PersonCard(data) {
  const { name, pic, organization, issue, reason, subject } = data;
  return (
    <div className="person-card">
      <div className="card-left">
        <div className="avatar-pic" style={{ backgroundImage: `url(${pic})` }} />
        <div className="info">
          <div className="name">{name}</div>
          <div className="org">{organization}</div>
        </div>
      </div>
      <div className="card-right">
        <div className="subject">
          <div className="subject-label green-bac">学科</div>
          <div className="subject-content">{subject}</div>
        </div>
        <div className="focus">
          <div className="focus-label green-bac">关注议题</div>
          <div className="focus-content">{issue}</div>
        </div>
        <div className="reason">
          <div className="reason-label green-bac">获奖理由</div>
          <div className="reason-content">{reason}</div>
        </div>
      </div>
    </div>
  );
}

const Laureates = () => {
  const [activeTab, setActiveTab] = useState(yearArray[0]);
  const onTabClick = (value) => {
    setActiveTab(value);
  };
  return (
    <div className="award-laureates">
      <AwardHeader />
      <div className="about-laureates block-container marker" style={{ marginTop: 150 }}>
        <span className="title">历届获奖人</span>
        <div className="laureates">
          <Tabs className="laureates-tab" value={activeTab} onTabClick={onTabClick}>
            {yearArray.map((year) => (
              <TabPane name={year} label={year} key={year}>
                <div className="laureates-list">
                  {laureatesData[year]?.map((person, index) => (
                    <PersonCard key={index} {...person} />
                  ))}
                </div>
              </TabPane>
            ))}
          </Tabs>
          <div className="partner-wrap">
            <Partner />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Laureates;
